<template>
    <div class="Wrapper pos-r mb-2">
        <WText
            tag="label"
            typo="label"
            size="14"
        >
            {{ $t(`entities.creation.labels.sources`) }}
        </WText>
        <div class="mb-1">
            <WSelect
                id="sources"
                :value="''"
                name="newTransform"
                :placeholder="$t(`entities.creation.placeholder.sourcesType`)"
                :options="optionsFiltered"
                :disabled="isLoading || isFetching"
                @input="handleChange"
            />
        </div>
        <FadeHeightTransitionGroup tag="div">
            <div
                v-for="({ key, label }) in optionsSelected"
                :key="key"
                class="Item"
            >
                <div class="flex row-stretch-top">
                    <WText
                        color="gray"
                        :size="14"
                        class="Label flex-1"
                    >
                        {{ label }}
                    </WText>
                    <div class="Code flex flex-1 row-stretch-top ml-1">
                        <WCode
                            :id="key"
                            :value="value[key]"
                            :placeholder="$t(`entities.creation.placeholder.sources`)"
                            :disabled="isLoading"
                            type="text"
                            class="flex-1"
                            @input="handleInput"
                        />
                        <WIcon
                            icon="trash"
                            class="Remove ml-1"
                            @click="removeTransform(key)"
                        />
                    </div>
                </div>
            </div>
        </FadeHeightTransitionGroup>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'
import { WCode } from '@/components'

export default {
    name: 'Sources',
    components: {
        WCode,
    },
    props: {
        value: VueTypes.any,
        isLoading: VueTypes.bool.def(false),
    },
    data () {
        return {
            options: undefined,
            isFetching: false,
        }
    },
    computed: {
        optionsFiltered () {
            const values = Object.keys(this.value || {}) || []
            return (this.options || []).filter(({ key }) => !values.includes(key))
        },
        optionsSelected () {
            const values = Object.keys(this.value || {}) || []
            return (this.options || []).filter(({ key }) => values.includes(key))
        },
    },
    mounted () {
        this.getOptions()
    },
    methods: {
        getOptions () {
            this.isFetching = true
            apiRequest(Api().sources.list())
                .then(({ data }) => (this.options = this.normalizeOptions(data)))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isFetching = false))
        },
        normalizeOptions (data) {
            return (data || []).map(({ key, name }) => ({ key, label: name }))
        },
        handleChange (key) {
            this.$emit('input', {
                ...this.value,
                [key]: '',
            })
        },
        handleInput (value, key) {
            this.$emit('input', {
                ...this.value,
                [key]: value,
            })
        },
        removeTransform (key) {
            const newValue = Object.keys(this.value).reduce((acc, type) => ({ ...acc, ...(type !== key ? { [type]: this.value[type] } : {}) }), {})
            this.$emit('input', newValue)
        },
    },
}
</script>

<style lang="scss" scoped>
.Loader {
    width: 100%;
    max-width: 280px;
    min-height: 50px;
}

.Item {
    width: 100%;

    & + .Item > div {
        margin-top: 8px;
        padding-top: 8px;
        border-top: solid 1px $gray-05;
    }
}

.Label, .Remove {
    margin-top: 10px;
}

.Code {
    width: 50%;

    .WCode {
        max-width: 322px;
    }
}

.Remove {
    margin-right: 13px;
    opacity: .5;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
}

.WSelect {
    &::v-deep {
        .multiselect__single {
            overflow: hidden;
        }
    }
}
</style>
